export { default } from './Slider';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/esm/Slider/index.js
// module id = 812
// module chunks = 121